// extracted by mini-css-extract-plugin
export default {"link":"LinkLight_link__wpwQI","disabled":"LinkLight_disabled__JBCAQ"};